export enum StatusCode {
  OK = 200,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  InternalServerError = 500,
}

export const getErrorMessageBasedOnCode = (code: StatusCode) => {
  switch (code) {
    case StatusCode.BadRequest:
      return "Something went wrong with your request. Try refreshing the page or checking your input.";
    case StatusCode.Unauthorized:
      return "Your session may have expired. Please close this window and reopen the page. If it keeps happening, log in again or contact support.";
    case StatusCode.Forbidden:
      return "You don’t have permission to view this content. If you think this is a mistake, please reach out to support.";
    case StatusCode.NotFound:
      return "We couldn’t find what you were looking for. Check the link or try again.";
    case StatusCode.InternalServerError:
      return "Oops! Something went wrong on our side. Please refresh the page and try again later.";
    default:
      return "An unexpected error occurred. Please refresh the page or try again later.";
  }
};
